import {
  convertLabelMapToConfig,
  convertLabelUomMapToConfig,
  mergeConfig,
} from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.HandShearVaneResultRequired`]: `Hand Shear Vane Result Required`,
      [`${prefix}.Preparation.SampleSusceptibleToCrushing`]: `Sample Susceptible to Crushing?`,
      [`${prefix}.Preparation.UsedSubSamples`]: `Sub-Samples Used`,
      [`${prefix}.Preparation.Balance`]: `Balance`,
      [`${prefix}.Preparation.OversizeMaterial`]: `Oversize Material`,
      [`${prefix}.Preparation.Sieve`]: `20mm Sieve Used`,
      [`${prefix}.Preparation.TareMass`]: `Tare Mass`,
      [`${prefix}.Preparation.TareAndTotalSampleMass`]: `Tare and Total Sample Mass`,
      [`${prefix}.Preparation.TotalSampleMass`]: `Total Sample Mass`,
      [`${prefix}.Preparation.MassRetainedOn20_0mmSieve`]: `Mass Retained on 20mm Sieve`,
      [`${prefix}.Preparation.MassRetainedOn20_0mmSievePercentage`]: `Retained on 20mm Sieve by Wet Mass`,
      [`${prefix}.Preparation.DryMassRetainedOn20_0mmSievePercentage`]: `Retained on 20mm Sieve by Dry Mass`,
      [`${prefix}.Preparation.TotalSampleDryMass`]: `Total Sample Dry Mass`,

      [`${prefix}.EmbeddedTests.Tests.Data.Preparation.WaterAddedTargetPercent`]: `Target Water Added`,
      [`${prefix}.EmbeddedTests.Tests.Data.Preparation.TestPortionMass`]: `Test Portion Mass`,

      [`${prefix}.EmbeddedTests.Tests.Data.Results.MoistureConditionValueText`]: `MCV`,
      [`${prefix}.EmbeddedTests.Tests.Data.Results.Exclude`]: `Exclude`,

      [`${prefix}.EmbeddedTests.Tests.Data.HandShearVane.Results.AverageVaneShearStrengthText`]: `Average Vane Shear Strength`,
    }),
    convertLabelUomMapToConfig({
      [`${prefix}.Preparation.MassRetainedOn20_0mmSievePercentage`]: '%',
      [`${prefix}.Preparation.DryMassRetainedOn20_0mmSievePercentage`]: '%',
      [`${prefix}.EmbeddedTests.Tests.Data.Preparation.WaterAddedTargetPercent`]: '%',
    })
  );

export default getLabelConfig;
